import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import { useStores } from '../../hooks/use-stores';
import SideBar from '../../components/SideBar/SideBar';
import {
  Row,
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
} from 'react-bootstrap';

const TestMode = observer((props) => {
  const { t } = props;
  const initialPumpGraduation = 1;
  const [ initialScaleGraduation, setInitialScaleGraduation ] = useState(25);
  const [ scaleChanel, setScaleChanel ] = useState(null);
  const [ scaleId, setScaleId ] = useState(null);
  const [ pumpMeter, setPumpMeter ] = useState(null);
  const [ scaleGraduation, setScaleGraduation ] = useState(initialScaleGraduation);
  const [ pumpGraduation, setPumpGraduation ] = useState(initialPumpGraduation);
  const { batchStore, devicesStore, pacSimulatorStore } = useStores();
  const { scales, pumps } = devicesStore;

  const changeScaleGraduation = () => {
    setScaleGraduation(scaleGraduation+10);
  };

  const changePumpGraduation = () => {
    setPumpGraduation(pumpGraduation+1);
  };

  const onScaleChange = (scaleId) => {
    const scale = devicesStore.scales.find(v => v.id === scaleId);
    setScaleId(scaleId);
    setScaleChanel(scale?.inputPNo);
    setScaleGraduation(scale?.graduation);
    setInitialScaleGraduation(scale?.graduation);
  };

  return (
    <SideBar type="testMode" title={t('Test Mode')} icon={'fa-check-circle'}>
      <Row>
        <Col sm={6}>
          <ControlLabel>{t('Scale')}</ControlLabel>
          <FormGroup>
            <FormControl
              name="scaleId"
              key="scaleId"
              componentClass="select"
              value={scaleId || ''}
              onChange={(e) => onScaleChange(Number(e.target.value))}
            >
              <option value=""/>
              {scales.map(scale => (
                <option key={scale.id} value={scale.id}>
                  {scale.description}
                </option>
              ))}
            </FormControl>
          </FormGroup>
        </Col>
        <Col sm={6}>
          <FormGroup>
            <ControlLabel>{t('Qty')}</ControlLabel>
            <FormControl
              key="scaleQty"
              name="scaleQty"
              type="number"
              step={scaleGraduation || 25}
              min={0}
              value={scaleChanel ? batchStore.channels[scaleChanel - 1] : ''}
              onChange={e => {
                changeScaleGraduation();
                pacSimulatorStore.setWeight(scaleChanel, e.target.value);
              }}
              onMouseUp={() => setScaleGraduation(initialScaleGraduation)}
              onKeyUp={() => setScaleGraduation(initialScaleGraduation)}
            />
          </FormGroup>
        </Col>
        <Col sm={6}>
          <ControlLabel>{t('Pump')}</ControlLabel>
          <FormGroup>
            <FormControl
              name="pumpMeter"
              key="pumpMeter"
              componentClass="select"
              value={pumpMeter || ''}
              onChange={(e) => setPumpMeter(e.target.value)}
            >
              <option value=""/>
              {pumps.map(pump => (
                <option key={pump.id} value={pump.meterPNo}>
                  {pump.description}
                </option>
              ))}
            </FormControl>
          </FormGroup>
        </Col>
        <Col sm={6}>
          <FormGroup>
            <ControlLabel>{t('Qty')}</ControlLabel>
            <FormControl
              key="pumpMeter"
              name="pumpMeter"
              type="number"
              min={0}
              step={pumpGraduation || 1}
              value={pumpMeter ? batchStore.meters[pumpMeter - 1] : ''}
              onChange={e => {
                changePumpGraduation();
                pacSimulatorStore.setMeter(pumpMeter, e.target.value);
              }}
              onMouseUp={() => setPumpGraduation(initialPumpGraduation)}
              onKeyUp={() => setPumpGraduation(initialPumpGraduation)}
            />
          </FormGroup>
        </Col>
      </Row>
    </SideBar>
  );

});

export default withTranslation()(TestMode);
